module.exports = __webpack_public_path__ + "static/media/provider3@2x.ddc81d33.png";